import { theme } from '../../theme.js';

const JotTheme = {
  ...theme,
  colors: {
    ...theme.colors,
    navbarLink: '#FFFFFF',
    navbarUnderline: '#1196AD',
    shellBgHeader: '#0C4E66',
    brandPrimary0: '#E5FBFF',
    brandPrimary100: '#BAECF5',
    brandPrimary200: '#77D5E5',
    brandPrimary300: '#55C1D4',
    brandPrimary400: '#1196AD',
    brandPrimary500: '#067C91',
    brandPrimary600: '#056778',
    brandPrimary700: '#065361',
    brandPrimary800: '#06424C',
    brandPrimary900: '#102E33'
  },
  config: {
    ...theme.config,
    FAVICON_ICO: 'https://apex-static-assets.s3.us-west-2.amazonaws.com/Themes/JotTheme/favicon.ico',
    FAVICON_16: 'https://apex-static-assets.s3.us-west-2.amazonaws.com/Themes/JotTheme/favicon-16x16.png',
    FAVICON_32: 'https://apex-static-assets.s3.us-west-2.amazonaws.com/Themes/JotTheme/favicon-32x32.png',
    FAVICON_48: 'https://apex-static-assets.s3.us-west-2.amazonaws.com/Themes/JotTheme/favicon-48x48.png',
    FAVICON_180: 'https://apex-static-assets.s3.us-west-2.amazonaws.com/Themes/JotTheme/favicon-180x180.png',
    FAVICON_192: 'https://apex-static-assets.s3.us-west-2.amazonaws.com/Themes/JotTheme/favicon-192x192.png',
    LOGO_DARK_FULL: 'https://apex-static-assets.s3.us-west-2.amazonaws.com/Themes/JotTheme/Jot-logo-black.png',
    LOGO_LIGHT_FULL: 'https://apex-static-assets.s3.us-west-2.amazonaws.com/Themes/JotTheme/Jot-logo-white.png',
    LOGO_DARK_BG_FULL: 'https://apex-static-assets.s3.us-west-2.amazonaws.com/Themes/JotTheme/Jot-logo-dark-bg.svg',
    LOGO_LIGHT_BG_FULL: 'https://apex-static-assets.s3.us-west-2.amazonaws.com/Themes/JotTheme/Jot-logo-light-bg.png',
    LOGO_MONO_BLUE_FULL: 'https://apex-static-assets.s3.us-west-2.amazonaws.com/Themes/JotTheme/Jot-logo-mono-blue.png',
    organization: 'Jot'
  }
};

export { JotTheme };
